import type { InjectionKey } from 'vue';

export type AwaitPromise<T extends PromiseLike<any> = PromiseLike<any>> = (promise: T) => T;

export const awaitPromiseSymbol: InjectionKey<AwaitPromise> = Symbol('addPromise');
